var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    staticClass: "d-flex h-100 w-100 overflow-auto px-0 position-absolute"
  }, [_c('div', {
    staticClass: "w-100 h-100"
  }, [_c('notification', {
    attrs: {
      "options": _vm.options,
      "show": _vm.showNotification
    },
    on: {
      "update:options": function($event) {
        _vm.options = $event
      },
      "update:show": function($event) {
        _vm.showNotification = $event
      },
      "close": _vm.closeNotification
    }
  }), _vm._v(" "), _c('checkbox-modal', {
    attrs: {
      "model": _vm.dob,
      "schema": _vm.dobField,
      "modalBody": _vm.dobBody,
      "formName": "dateForm",
      "hasInput": "false",
      "hasClose": "false",
      "show": _vm.ageVerification
    },
    on: {
      "update:modalBody": function($event) {
        _vm.dobBody = $event
      },
      "update:modal-body": function($event) {
        _vm.dobBody = $event
      },
      "update:show": function($event) {
        _vm.ageVerification = $event
      },
      "checkValues": _vm.checkDOB
    }
  }, [_c('div', {
    attrs: {
      "slot": "action"
    },
    slot: "action"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "spnod-form__button spnod-button--primary",
    attrs: {
      "type": "button",
      "disabled": _vm.isDisabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.setDOB()
      }
    }
  }, [_vm._v("OK")])])]), _vm._v(" "), _c('checkbox-modal', {
    attrs: {
      "model": _vm.terms,
      "schema": _vm.clientTermsSchema,
      "modalBody": _vm.clientTermsBody,
      "formName": "clientTermsForm",
      "hasInput": "false",
      "hasClose": "false",
      "show": (_vm.actionRequired === 'agreeTerms' || _vm.actionRequired === 'confirmMedical') && _vm.getMyInfo._id === _vm.activeClient
    },
    on: {
      "update:modalBody": function($event) {
        _vm.clientTermsBody = $event
      },
      "update:modal-body": function($event) {
        _vm.clientTermsBody = $event
      },
      "checkValues": _vm.checkTerms
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v("Terms & Conditions")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "action"
    },
    slot: "action"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "spnod-form__button spnod-button--primary",
    attrs: {
      "type": "button",
      "disabled": _vm.termsProvided === false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.setTerms()
      }
    }
  }, [_vm._v("\n              OK\n          ")])])]), _vm._v(" "), _c('checkbox-modal', {
    attrs: {
      "model": {},
      "schema": [],
      "modalBody": _vm.additionalEmailsBody,
      "formName": "additionalEmailsForm",
      "hasInput": "false",
      "hasClose": "false",
      "show": _vm.actionRequired === 'requireAdditionalUser'
    },
    on: {
      "update:modalBody": function($event) {
        _vm.additionalEmailsBody = $event
      },
      "update:modal-body": function($event) {
        _vm.additionalEmailsBody = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "action"
    },
    slot: "action"
  }, [_c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "spnod-form__button spnod-button--primary",
    attrs: {
      "to": {
        name: 'addParent',
        params: {
          fromRoute: this.$route.name,
          signupData: _vm.getMyInfo
        }
      }
    }
  }, [_vm._v("\n            OK\n          ")])], 1)]), _vm._v(" "), _c('checkbox-modal', {
    attrs: {
      "model": _vm.terms,
      "schema": _vm.parentTermsSchema,
      "modalBody": _vm.parentTermsBody,
      "formName": "parentTermsForm",
      "hasInput": "false",
      "hasClose": "false",
      "show": _vm.actionRequired === 'agreeTerms' && _vm.getMyInfo._id !== _vm.activeClient
    },
    on: {
      "update:modalBody": function($event) {
        _vm.parentTermsBody = $event
      },
      "update:modal-body": function($event) {
        _vm.parentTermsBody = $event
      },
      "checkValues": _vm.checkTerms
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v("Terms & Conditions")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "action"
    },
    slot: "action"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "spnod-form__button spnod-button--primary",
    attrs: {
      "type": "button",
      "disabled": _vm.termsProvided === false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.setTerms()
      }
    }
  }, [_vm._v("\n            OK\n          ")])])]), _vm._v(" "), _c('checkbox-modal', {
    attrs: {
      "model": _vm.myConsent,
      "schema": _vm.provideConsentSchema,
      "modalBody": _vm.provideConsentBody,
      "hasInput": "false",
      "hasClose": "false",
      "show": _vm.actionRequired === 'provideConsent' && _vm.getMyInfo._id !== _vm.activeClient && !_vm.getMyInfo.hasRoles
    },
    on: {
      "update:modalBody": function($event) {
        _vm.provideConsentBody = $event
      },
      "update:modal-body": function($event) {
        _vm.provideConsentBody = $event
      },
      "checkValues": _vm.checkIfConsented
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v("Please provide consent for " + _vm._s(_vm.clientName))])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "action"
    },
    slot: "action"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "spnod-form__button spnod-button--primary",
    attrs: {
      "type": "button",
      "disabled": _vm.consentProvided === false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.setConsent()
      }
    }
  }, [_vm._v("\n            OK\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "spnod-messages w-100 h-100 d-flex flex-column p-2"
  }, [(_vm.consentMessage !== null) ? _c('div', {
    staticClass: "d-flex flex-column h-100 w-100"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.consentMessage)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grow-1"
  }), _vm._v(" "), (_vm.showSubscribe) ? _c('router-link', {
    staticClass: "mx-auto",
    attrs: {
      "to": "/payment"
    }
  }, [_c('b-button', {
    staticClass: "spnod-admin__form--button mb-2",
    attrs: {
      "size": "sm"
    }
  }, [_vm._v("Subscribe")])], 1) : _vm._e(), _vm._v(" "), (_vm.showParentSubscribe) ? _c('router-link', {
    staticClass: "mx-auto",
    attrs: {
      "to": "/user"
    }
  }, [_c('b-button', {
    staticClass: "spnod-admin__form--button mb-2",
    attrs: {
      "size": "sm"
    }
  }, [_vm._v("Manage Users")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.showMessages && _vm.loading) ? _c('div', {
    staticClass: "d-flex flex-column h-100 w-100"
  }, [_c('div', {
    staticClass: "loader mx-auto"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grow-1 overflow-auto spnod-messages-container"
  }, _vm._l((_vm.getMessages), function(message, index) {
    return _c('MessageBody', {
      key: index,
      attrs: {
        "message": message,
        "index": index
      }
    })
  }), 1), _vm._v(" "), (!_vm.displayTextarea() && _vm.showParentSubscribe) ? _c('router-link', {
    staticClass: "mx-auto",
    attrs: {
      "to": "/user"
    }
  }, [_c('b-button', {
    staticClass: "spnod-admin__form--button mb-2",
    attrs: {
      "size": "sm"
    }
  }, [_vm._v("Manage Users")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showMessages) ? _c('div', {
    staticClass: "d-flex flex-column h-100 w-100"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "d-flex flex-column h-100 w-100"
  }, [_c('div', {
    staticClass: "loader mx-auto mb-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grow-1"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-grow-1 overflow-auto spnod-messages-container"
  }, _vm._l((_vm.uniqueMessages), function(message, index) {
    return _c('MessageBody', {
      key: index,
      attrs: {
        "message": message,
        "index": index
      },
      on: {
        "initScrollListener": _vm.initScrollListener
      }
    })
  }), 1), _vm._v(" "), (_vm.actionRequired === 'parentAwaitingClient') ? _c('div', {
    staticClass: "pt-3"
  }, [_c('p', {
    staticClass: "text-center text-primary"
  }, [_vm._v("\n            Awaiting all message participants to complete account activation before messaging can begin\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.displayTextarea() && _vm.actionRequired !== 'parentAwaitingClient') ? _c('TextArea', {
    staticClass: "pt-3",
    attrs: {
      "id": "textarea",
      "model": _vm.model,
      "consented": _vm.consented
    },
    on: {
      "sendMessage": _vm.sendMessage,
      "scrollPage": _vm.scrollPage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSubscribe) ? _c('router-link', {
    staticClass: "mx-auto",
    attrs: {
      "to": "/payment"
    }
  }, [_c('b-button', {
    staticClass: "spnod-admin__form--button mb-2",
    attrs: {
      "size": "sm"
    }
  }, [_vm._v("Subscribe")])], 1) : _vm._e(), _vm._v(" "), (!_vm.displayTextarea() && _vm.showParentSubscribe) ? _c('router-link', {
    staticClass: "mx-auto",
    attrs: {
      "to": "/user"
    }
  }, [_c('b-button', {
    staticClass: "spnod-admin__form--button mb-2",
    attrs: {
      "size": "sm"
    }
  }, [_vm._v("Manage Users")])], 1) : _vm._e()], 1) : _vm._e()])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3221a6ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Messaging/MessageThread.vue
// module id = EQkR
// module chunks = 2